export default class Inputs{
    constructor(){
        this.keys = new Array();
        this.mouse_position = {x: 0, y: 0};
        this.mouse_delta = {x: 0, y: 0};

        document.onkeydown = (e) => {
            this.removeKey(e.code);
            this.keys.push(e.code);
        };

        document.onmousedown = (e)=>{
            this.removeKey("click");
            this.keys.push("click");
            e.preventDefault();
        }

        document.onmouseup = (e)=>{
            this.removeKey("click");
        }

        document.onmousemove = (e)=>{
            this.mouse_position.x = e.clientX;
            this.mouse_position.y = e.clientY;
            this.mouse_delta.x = e.movementX;
            this.mouse_delta.y = e.movementY;
        }

        document.onkeyup = (e) => {
            this.removeKey(e.code);
        };
    }

    getKey(key){
        for(let i = 0; i < this.keys.length; i++){
            if(this.keys[i] == key){
                return true;
            }
        }
        return false;
    }

    getAxis(negative, positive){
        if(this.getKey(negative)) return -1;
        if(this.getKey(positive)) return 1;
        return 0;
    }

    removeKey(key){
        for(let i = 0; i < this.keys.length; i++){
            if(this.keys[i] == key){
                this.keys.splice(i,1);
            }
        }
    }
}
